module.exports = __webpack_public_path__ + "static/Astrocytes-6a852c14723a55ed17360cb6e3cb93e1.jpg";